// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MailClosedIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MailClosedIcon" ref={forwardedRef} {...props}>
      <path d="M3.5 14.5V6.46l6.502 5.526 6.498-5.57v3.874l1.5-1.5V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7.79l1.5-1.5zm1.188-9h10.576l-5.266 4.514z" />
      <path d="m16.03 15.022 1.921 1.92L19 15.895l-1.922-1.92 1.872-1.87-1.048-1.047-1.873 1.87L14.1 11l-1.05 1.047 1.932 1.928L13 15.953 14.049 17z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MailClosedIcon = /* @__PURE__ */ Object.assign(
  MailClosedIconComponent,
  { displayName: 'MailClosedIcon' },
);
